import { useEffect, useState } from 'react'
import Header from './Header'
import BottomNav from './BottomNav'
import LegalFooter from './LegalFooter'
import { useDashboardStore } from '../../store/dashboardStore'
import { setImpersonate, adminSetViewMode } from '../../services/api'

export default function MainLayout({ children }) {
  const activeTab = useDashboardStore(s => s.activeTab)

  // «Режим юзера» (п.1-7 task.txt): плавающая плашка, пока админ смотрит
  // приложение как новый юзер. Клик по ней — выход из режима. Состояние берём
  // из localStorage (им же управляется заголовок X-Impersonate, см. api.js).
  const [viewMode, setViewMode] = useState(() => {
    try { return localStorage.getItem('scalpex-view-mode') === '1' } catch { return false }
  })
  const [leaving, setLeaving] = useState(false)

  const exitViewMode = async () => {
    if (leaving) return
    setLeaving(true)
    // Путь /api/admin/ не имперсонируется, поэтому запрос уходит как админ даже
    // пока флаг ещё поднят. Сбрасываем флаг сразу — после reload фронт стартует
    // как админ.
    setImpersonate(false)
    setViewMode(false)
    try { await adminSetViewMode(false) } catch { /* не критично: флаг уже снят */ }
    window.location.reload()
  }

  useEffect(() => {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual'
  }, [])

  return (
    /* Outer — занимает ровно 100dvh, без overflow */
    <div
      style={{
        background: '#050505',
        height: 'var(--tg-app-height, 100dvh)',
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {/* App shell — центрирован, max 480px, ровно высота экрана */}
      <div
        style={{
          background: '#0A0A0A',
          width: '100%',
          maxWidth: 480,
          height: 'var(--tg-app-height, 100dvh)',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 0 80px rgba(0,0,0,0.8)',
        }}
      >
        {/* Плашка «Режим юзера» — всегда видна, пока включён */}
        {viewMode && (
          <button
            onClick={exitViewMode}
            disabled={leaving}
            style={{
              position: 'absolute',
              // Под шапкой (header sticky ~60px), а не поверх логотипа.
              top: 66, left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 60,
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '6px 12px',
              background: 'rgba(20,20,22,0.92)',
              border: '1px solid rgba(255,149,0,0.45)',
              borderRadius: 20,
              fontSize: 11.5, fontWeight: 600, color: '#FFB74D',
              cursor: leaving ? 'default' : 'pointer',
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
              WebkitTapHighlightColor: 'transparent',
            }}
          >
            <span>🔍 Режим юзера включён</span>
            <span style={{ color: '#8E8E93', fontWeight: 500 }}>
              {leaving ? '…' : '· Выйти'}
            </span>
          </button>
        )}
        {/* Glow — мягкое emerald-свечение, без «красного угла» и крупного зерна */}
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '70%',
            height: '46%',
            background:
              'radial-gradient(ellipse at 100% 0%, rgba(16,185,129,0.28) 0%, rgba(16,185,129,0.10) 30%, transparent 70%)',
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />

        {/* Content */}
        <div
          style={{
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <Header />
          <main
            key={activeTab}
            className="tab-fade-in"
            style={{
              flex: 1,
              overflowY: 'auto',
              overflowX: 'hidden',
              overscrollBehavior: 'none',
              overscrollBehaviorY: 'none',
              WebkitOverflowScrolling: 'touch',
              padding: '12px 16px 0',
              paddingBottom: 'calc(72px + env(safe-area-inset-bottom))',
            }}
          >
            {children}
            {/* Юр. футер (Волна 0.3): «не финсовет · 18+» + ссылки на ToS/Privacy */}
            <LegalFooter />
          </main>
          <BottomNav />
        </div>
      </div>
    </div>
  )
}
